import React from "react";
import "./_crt.scss";

const CRTOverlay = props => (
  <div className="container">
    <div className="screen" />
  </div>
);

export default CRTOverlay;
